(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alpha-collection-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('alpha-collection-gallery')) {
    customElements.define('alpha-collection-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.container = this.closest('results-list');
        this.dialog = this.querySelector('dialog');
        if (!this.container || !this.dialog || !this.dialog.showModal) return;
        this.controller = new AbortController();
        this.entries = [];
        this.requests = new Map();
        this.loadedPages = new Set();
        this.index = 0;
        this.version = 0;
        this.playing = false;
        this.image = this.dialog.querySelector('[data-gallery-image]');
        this.status = this.dialog.querySelector('[role="status"]');
        this.titleNode = this.dialog.querySelector('[data-gallery-title]');
        this.link = this.dialog.querySelector('[data-gallery-product]');
        this.count = this.dialog.querySelector('.alpha-gallery-count');
        this.prev = this.dialog.querySelector('[data-gallery-prev]');
        this.next = this.dialog.querySelector('[data-gallery-next]');
        this.play = this.dialog.querySelector('[data-gallery-play]');
        this.pageSize = Number(this.dataset.pageSize) || 24;
        this.total = Number(this.dataset.total) || 0;
        this.pages = Number(this.dataset.pages) || 1;
        this.baseURL = location.href;
        this.dialog.setAttribute('dir', getComputedStyle(this).direction);
        document.body.appendChild(this.dialog);
        const listen = (node, type, fn, options = {}) => node.addEventListener(type, fn, { ...options, signal: this.controller.signal });
        listen(this, 'click', event => {
          if (event.target.closest('[data-gallery-launch]')) this.open();
        });
        listen(this.container, 'click', event => {
          const button = event.target.closest('[data-alpha-gallery-open]');
          if (!button) return;
          event.preventDefault();
          this.open(button.closest('[data-alpha-product-card]')?.dataset.alphaProductId, button);
        });
        listen(document, 'alpha:openCollectionSlideshowAt', event => {
          const card = this.container.querySelector('[data-alpha-product-handle="' + CSS.escape(event.detail?.handle || '') + '"]');
          if (card) this.open(card.dataset.alphaProductId);
        });
        listen(this.dialog.querySelector('[data-gallery-close]'), 'click', () => this.close());
        listen(this.dialog, 'cancel', event => { event.preventDefault(); this.close(); });
        listen(this.dialog, 'close', () => this.cleanup());
        listen(this.prev, 'click', () => { this.stop(); this.step(-1); });
        listen(this.next, 'click', () => { this.stop(); this.step(1); });
        listen(this.play, 'click', () => {
          if (this.playing) this.stop();
          else { this.playing = true; this.play.textContent = this.dataset.pause; this.play.setAttribute('aria-pressed', 'true'); this.schedule(); }
        });
        listen(this.dialog, 'keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); this.stop(); this.step(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
        listen(this.dialog, 'touchstart', event => {
          if (event.touches.length === 1) this.touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
          else this.touch = null;
        }, { passive: true });
        listen(this.dialog, 'touchend', event => {
          if (!this.touch || event.changedTouches.length !== 1) return;
          const dx = event.changedTouches[0].clientX - this.touch.x;
          const dy = event.changedTouches[0].clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) { this.stop(); this.step(dx < 0 ? 1 : -1); }
        }, { passive: true });
        listen(document, 'visibilitychange', () => { if (document.hidden) this.stop(); });
        this.buildPreview();
        this.container.setAttribute('data-alpha-gallery-ready', '');
        this.hidden = false;
      }
      buildPreview() {
        const preview = this.querySelector('[data-gallery-preview]');
        if (!preview) return;
        const images = Array.from(this.container.querySelectorAll('[data-alpha-product-card] img')).slice(0, 3);
        preview.replaceChildren(...images.map(original => {
          const image = document.createElement('img');
          image.alt = '';
          image.width = 76;
          image.height = 108;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.src = original.currentSrc || original.getAttribute('src');
          return image;
        }));
      }
      readCards(root) {
        return Array.from(root.querySelectorAll('[data-alpha-product-card]')).map(card => ({
          id: card.dataset.alphaProductId,
          handle: card.dataset.alphaProductHandle,
          title: card.querySelector('.alpha-product-card__title')?.textContent.trim() || card.dataset.alphaProductTitle,
          url: card.dataset.alphaProductUrl,
          image: card.dataset.alphaGalleryImage || card.dataset.alphaProductImage,
          thumb: card.querySelector('img')?.currentSrc || card.querySelector('img')?.getAttribute('src'),
          ratio: Number(card.dataset.alphaGalleryRatio) || 1,
          page: Number(card.closest('[data-page]')?.dataset.page) || Number(this.dataset.page),
        })).filter(item => item.id && item.url && item.image);
      }
      merge(items) {
        const active = this.entries[this.index]?.id;
        const known = new Set(this.entries.map(item => item.id));
        for (const item of items) {
          this.loadedPages.add(item.page);
          if (!known.has(item.id)) { this.entries.push(item); known.add(item.id); }
        }
        this.entries.sort((a, b) => a.page - b.page);
        if (active) this.index = this.entries.findIndex(item => item.id === active);
      }
      open(id, trigger) {
        if (this.dialog.open) return;
        this.baseURL = location.href;
        this.session = (this.session || 0) + 1;
        this.entries = [];
        this.loadedPages.clear();
        this.merge(this.readCards(this.container));
        if (!this.entries.length) return;
        this.index = Math.max(0, this.entries.findIndex(item => item.id === id));
        this.trigger = trigger || this.querySelector('[data-gallery-launch]');
        this.oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
        this.show();
      }
      source(item) {
        const url = new URL(item.image, location.origin);
        if (url.pathname.includes('/cdn/shop/') || url.hostname === 'cdn.shopify.com') {
          const slow = navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || '');
          const stage = this.dialog.querySelector('.alpha-gallery-stage').getBoundingClientRect();
          const displayWidth = Math.min(stage.width, stage.height * (item.ratio || 1));
          const width = Math.max(400, Math.min(slow ? 900 : 1500, Math.ceil(displayWidth * Math.min(devicePixelRatio || 1, slow ? 1 : 1.5) / 100) * 100));
          url.searchParams.set('width', String(width));
          url.searchParams.delete('height');
          url.searchParams.delete('crop');
        }
        return url.href;
      }
      show() {
        const item = this.entries[this.index];
        if (!item || !this.dialog.open) return;
        const version = ++this.version;
        clearTimeout(this.timer);
        this.titleNode.textContent = item.title;
        this.link.href = item.url;
        this.count.textContent = ((Math.min(...this.loadedPages) - 1) * this.pageSize + this.index + 1) + ' / ' + this.total;
        this.prev.disabled = this.index === 0 && this.loadedPages.has(1);
        this.next.disabled = this.index === this.entries.length - 1 && this.loadedPages.has(this.pages);
        this.status.textContent = this.dataset.loading;
        this.image.alt = item.title;
        this.image.hidden = !item.thumb;
        if (item.thumb) this.image.src = item.thumb;
        else this.image.removeAttribute('src');
        const source = this.source(item);
        const loader = new Image();
        loader.decoding = 'async';
        loader.onload = () => {
          if (version !== this.version || !this.dialog.open) return;
          this.image.src = source;
          this.image.hidden = false;
          this.status.textContent = '';
          this.schedule();
          if (!navigator.connection?.saveData && !/(^|-)2g$/.test(navigator.connection?.effectiveType || '')) {
            const following = this.entries[this.index + 1];
            if (following) { const preload = new Image(); preload.decoding = 'async'; preload.src = this.source(following); }
          }
        };
        loader.onerror = () => {
          if (version !== this.version || !this.dialog.open) return;
          this.status.textContent = this.dataset.error;
          this.stop();
          if (item.thumb && item.thumb !== source) { this.image.src = item.thumb; this.image.hidden = false; }
        };
        loader.src = source;
      }
      async page(number) {
        if (number < 1 || number > this.pages || this.loadedPages.has(number)) return;
        if (this.requests.has(number)) return this.requests.get(number);
        const session = this.session;
        const request = (async () => {
          const url = new URL(this.baseURL);
          url.searchParams.set('page', String(number));
          url.searchParams.set('sections', this.dataset.section);
          url.hash = '';
          const abort = new AbortController();
          this.pageAbort = abort;
          const timeout = setTimeout(() => abort.abort(), 12000);
          try {
            const response = await fetch(url, { signal: abort.signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error('Gallery page unavailable');
            const json = await response.json();
            const html = json[this.dataset.section];
            if (!html) throw new Error('Gallery section unavailable');
            const template = document.createElement('template');
            template.innerHTML = html;
            const items = this.readCards(template.content);
            if (!items.length) throw new Error('Gallery page empty');
            if (this.dialog.open && session === this.session) this.merge(items);
          } finally { clearTimeout(timeout); }
        })().finally(() => this.requests.delete(number));
        this.requests.set(number, request);
        return request;
      }
      async step(direction) {
        if (this.moving || !this.dialog.open) return;
        this.moving = true;
        try {
          if (this.index + direction >= this.entries.length) {
            const last = Math.max(...this.loadedPages);
            if (last >= this.pages) { this.stop(); return; }
            this.status.textContent = this.dataset.loading;
            await this.page(last + 1);
          } else if (this.index + direction < 0) {
            const first = Math.min(...this.loadedPages);
            if (first <= 1) return;
            this.status.textContent = this.dataset.loading;
            await this.page(first - 1);
          }
          if (!this.dialog.open) return;
          this.index = Math.max(0, Math.min(this.entries.length - 1, this.index + direction));
          this.show();
        } catch (_error) { this.status.textContent = this.dataset.error; this.stop(); }
        finally { this.moving = false; }
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.playing && this.dialog.open && !document.hidden) this.timer = setTimeout(() => this.step(1), 6000);
      }
      stop() {
        this.playing = false;
        clearTimeout(this.timer);
        this.play.textContent = this.dataset.play;
        this.play.setAttribute('aria-pressed', 'false');
      }
      close() { this.dialog.close(); }
      cleanup() {
        this.stop();
        this.version++;
        this.pageAbort?.abort();
        document.documentElement.style.overflow = this.oldOverflow || '';
        this.image.removeAttribute('src');
        this.image.hidden = true;
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        if (!this.controller) return;
        if (this.dialog.open) this.close();
        this.controller.abort();
        this.pageAbort?.abort();
        this.dialog.remove();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["artwork-credit-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('artwork-credit-cart')) customElements.define('artwork-credit-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true; this.items = []; this.configured = []; this.nativeItems = []; this.wallet = null; this.busy = false; this.storageOK = true; this.pending = false; this.requestKey = null; this.pendingState = null; this.checkoutUrl = null; this.requestItems = null; this.lastMessage = null;
      this.dialog = this.querySelector('dialog'); this.abort = new AbortController();
      this.key = `artwork-wallet-v2:${this.dataset.shop}:${this.dataset.owner}`;
      this.endpoint = new URL(this.dataset.endpoint, location.origin);
      if (this.endpoint.origin !== location.origin || this.endpoint.pathname !== '/apps/alpha-reproduction-pod') return;
      this.load(); this.mergeGuest(); this.render();
      this.querySelectorAll('[data-pack-price]').forEach(node => { node.textContent = this.money(Number(node.dataset.packPrice)); });
      const options = { signal: this.abort.signal };
      this.querySelector('[data-open]').addEventListener('click', () => this.open(), options);
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), options);
      const outsideDialog = event => {
        const bounds = this.dialog.getBoundingClientRect();
        return event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
      };
      this.dialog.addEventListener('pointerdown', event => { this.backdropPress = outsideDialog(event); }, options);
      this.dialog.addEventListener('pointercancel', () => { this.backdropPress = false; }, options);
      this.dialog.addEventListener('click', event => {
        const dismiss = this.backdropPress && outsideDialog(event);
        this.backdropPress = false;
        if (dismiss) this.dialog.close();
      }, options);
      this.querySelector('[data-checkout]').addEventListener('click', () => this.checkout(), options);
      this.querySelector('[data-retry]').addEventListener('click', () => this.refresh(true), options);
      this.querySelector('[data-address]').addEventListener('submit', event => { event.preventDefault(); this.checkout(); }, options);
      this.querySelectorAll('[data-pack]').forEach(button => button.addEventListener('click', () => this.buyPack(button.dataset.pack), options));
      document.addEventListener('click', event => {
        const packEntry = event.target.closest('[data-credit-pack-select]');
        if (packEntry) { event.preventDefault(); this.open(); this.buyPack(packEntry.dataset.creditPackSelect); return; }
        const entry = event.target.closest('[data-credit-open]');
        if (entry && !entry.matches('[data-hvhd-cart],[data-hvhd-drawer-cart]')) { event.preventDefault(); event.stopPropagation(); this.open(); return; }
        const button = event.target.closest('[data-credit-add]'); if (!button) return;
        event.preventDefault(); event.stopPropagation();
        if (this.busy || this.pending) { this.open(); return; }
        const item = this.clean({id: button.dataset.productId, title: button.dataset.title, url: button.dataset.url, image: button.dataset.image, useCredit: true});
        if (!item || this.items.length >= 100) return;
        if (!this.items.some(row => row.id === item.id)) { this.items.push(item); this.requestKey = null; this.pendingState = null; this.save(); }
        this.open();
      }, {...options, capture: true});
      window.addEventListener('storage', event => { if (event.key === this.key && !this.busy) { this.load(); this.render(); if (this.dialog.open) this.refresh(true); } }, options);
      document.addEventListener('visibilitychange', () => { if (!document.hidden && this.pending) this.refresh(true); }, options);
      window.addEventListener('pageshow', () => { this.load(); this.render(); if (this.pending) this.refresh(true); }, options);
      document.addEventListener('cart:update', () => { if (this.dialog.open && !this.pending) this.refresh(); }, options);
      document.addEventListener('shopify:section:load', () => this.syncEntries(), options);
      this.mountPhysicalActions();
      this.pageObserver = new MutationObserver(() => this.mountPhysicalActions());
      this.pageObserver.observe(document.getElementById('MainContent') || document.body,{childList:true,subtree:true});
      if (this.dataset.owner !== 'guest') this.refresh(this.pending);
    }
    disconnectedCallback() { this.abort?.abort(); this.pageObserver?.disconnect(); this.ready = false; }
    copy(key) { return this.querySelector('[data-copy]').content.querySelector(`[data-key="${key}"]`)?.textContent || ''; }
    message(key) { const status = this.querySelector('[data-status]'); status.textContent = this.copy(key); status.hidden = key === 'login' && this.dataset.owner === 'guest'; }
    syncEntries() {
      const count = String(this.items.length + this.configured.length);
      document.querySelectorAll('[data-credit-entry-count]').forEach(node => { if (node.textContent !== count) node.textContent = count; });
      document.querySelectorAll('[data-credit-entry-label]').forEach(node => node.setAttribute('aria-label',`${node.dataset.creditEntryLabel} · ${count}`));
    }
    open() { if (!this.dialog.open) this.dialog.showModal(); this.render(); this.refresh(this.pending); }
    clean(value) {
      if (!value || !/^gid:\/\/shopify\/Product\/[1-9]\d*$/.test(value.id) || typeof value.title !== 'string') return null;
      try {
        const url = new URL(value.url, location.origin);
        if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return null;
        let image = '';
        if (value.image) { const src = new URL(value.image, location.origin); if (src.protocol === 'https:' && !src.username && !src.password && (src.hostname === location.hostname || src.hostname === 'cdn.shopify.com')) { src.searchParams.set('width','180'); image = src.href; } }
        return {id:value.id,title:value.title.slice(0,300),url:url.pathname,image,useCredit:value.useCredit !== false};
      } catch { return null; }
    }
    cleanConfigured(value) {
      const artwork = this.clean(value);
      if (!artwork || !/^gid:\/\/shopify\/ProductVariant\/[1-9]\d*$/.test(value.variantId || '') || !/^[A-Z]{2}$/.test(value.country || '') || typeof value.optionId !== 'string' || value.optionId.length > 1000 || typeof value.quoteToken !== 'string' || value.quoteToken.length > 8192 || !Number.isSafeInteger(value.priceCents) || value.priceCents < 0) return null;
      return {...artwork,variantId:value.variantId,country:value.country,optionId:value.optionId,quoteToken:value.quoteToken,priceCents:value.priceCents,label:String(value.label || '').slice(0,500)};
    }
    load() {
      try {
        const raw = localStorage.getItem(this.key); if (raw?.length > 1000000) throw Error('STORAGE');
        const data = JSON.parse(raw || '{}');
        this.items = (Array.isArray(data.items) ? data.items : []).slice(0,100).map(item => this.clean(item)).filter(Boolean);
        this.items = this.items.filter((row,index,rows) => rows.findIndex(other => other.id === row.id) === index);
        this.configured = (Array.isArray(data.configured) ? data.configured : []).slice(0,10).map(item => this.cleanConfigured(item)).filter(Boolean);
        this.requestKey = /^[A-Za-z0-9_-]{16,128}$/.test(data.requestKey || '') ? data.requestKey : null;
        this.pending = data.pending === true && Boolean(this.requestKey);
        this.pendingState = this.pending ? 'VERIFYING' : null; this.checkoutUrl = null;
        this.requestItems = this.pending && data.digitalOnly === true ? this.items.map(item => ({productId:item.id,kind:'digital',quantity:1,useCredit:item.useCredit})) : null;
      } catch { this.storageOK = false; }
    }
    save() {
      try { localStorage.setItem(this.key,JSON.stringify({items:this.items,configured:this.configured,requestKey:this.requestKey,pending:this.pending,digitalOnly:Boolean(this.requestItems?.length && this.requestItems.every(item => item.kind === 'digital'))})); }
      catch { this.storageOK = false; this.message('storage'); }
    }
    mergeGuest() {
      if (this.dataset.owner === 'guest' || this.pending) return;
      try {
        const guestKey = `artwork-wallet-v2:${this.dataset.shop}:guest`, raw = localStorage.getItem(guestKey);
        if (!raw) return; if (raw.length > 200000) throw Error('STORAGE');
        const guest = JSON.parse(raw);
        for (const candidate of (Array.isArray(guest.items) ? guest.items : []).slice(0,100)) { const item = this.clean(candidate); if (item && this.items.length < 100 && !this.items.some(other => other.id === item.id)) this.items.push(item); }
        for (const candidate of (Array.isArray(guest.configured) ? guest.configured : []).slice(0,10)) { const item = this.cleanConfigured(candidate); if (item && this.configured.length < 10 && !this.configured.some(other => other.id === item.id && other.optionId === item.optionId && other.country === item.country)) this.configured.push(item); }
        this.save(); if (this.storageOK) localStorage.removeItem(guestKey);
      } catch { this.storageOK = false; }
    }
    creditCount() { return this.items.filter(item => item.useCredit).length; }
    pendingMessage() { return this.pendingState === 'OPEN' ? 'resume' : this.pendingState === 'RETRY_SAFE' ? 'error' : this.pendingState === 'VERIFYING' ? 'loading' : 'pending'; }
    remainingCredits() { return this.wallet ? Math.max(0,this.wallet.available - (this.pending && this.pendingState !== 'RETRY_SAFE' ? 0 : this.creditCount())) : '—'; }
    money(cents, currency = 'EUR') { try { return new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency}).format(cents/100); } catch { return `${(cents/100).toFixed(2)} ${currency}`; } }
    render() {
      const count = this.creditCount(), frozen = this.wallet?.frozen === true;
      this.querySelector('[data-count]').textContent = this.items.length + this.configured.length;
      this.syncEntries();
      this.querySelector('[data-wallet-summary]').textContent = this.wallet ? this.wallet.available : '—';
      this.querySelector('[data-empty]').hidden = this.items.length + this.configured.length > 0;
      this.querySelector('[data-login]').hidden = this.dataset.owner !== 'guest';
      this.querySelector('[data-balance-box]').hidden = !this.wallet;
      for (const [attribute,key] of [['available','available'],['reserved','reserved'],['used','spent']]) this.querySelector(`[data-${attribute}]`).textContent = this.wallet?.[key] ?? '—';
      this.querySelector('[data-selected-count]').textContent = count;
      this.querySelector('[data-remaining]').textContent = this.remainingCredits();
      this.querySelector('[data-orders]').hidden = this.pendingState !== 'COMPLETE';
      const paid = this.items.length - count, paidNode = this.querySelector('[data-paid-digital]'); paidNode.hidden = paid === 0; paidNode.textContent = `${this.copy('paid_digital')} ${this.money(paid * 990)}`;
      const list = this.querySelector('[data-items]'); list.replaceChildren();
      for (const item of this.items) {
        const row = document.createElement('li'), image = document.createElement('img'), content = document.createElement('div'), link = document.createElement('a'), label = document.createElement('label'), toggle = document.createElement('input'), remove = document.createElement('button');
        image.alt = ''; image.width = 68; image.height = 76; image.loading = 'lazy'; if (item.image) image.src = item.image;
        link.href = item.url; link.textContent = item.title;
        toggle.type = 'checkbox'; toggle.checked = item.useCredit; toggle.disabled = this.busy || this.pending;
        const note = document.createElement('span'); note.textContent = item.useCredit ? this.copy('use_credit') : `${this.copy('pay_individually')} ${this.money(990)}`;
        toggle.addEventListener('change', () => { item.useCredit = toggle.checked; this.requestKey = null; this.pendingState = null; this.save(); this.render(); });
        label.append(toggle,note); content.append(link,label);
        remove.type = 'button'; remove.textContent = this.copy('remove'); remove.disabled = this.busy || this.pending;
        remove.addEventListener('click', () => { this.items = this.items.filter(other => other.id !== item.id); this.requestKey = null; this.pendingState = null; this.save(); this.render(); });
        row.append(image,content,remove); list.append(row);
      }
      this.renderNative();
      const digital = this.items.length > 0;
      this.querySelector('[data-digital-rule]').hidden = !digital;
      this.querySelector('.artwork-wallet-header p').hidden = !digital;
      this.querySelector('[data-balance-box]').hidden = !digital || !this.wallet;
      this.querySelector('[data-login]').hidden = !digital || this.dataset.owner !== 'guest';
      this.querySelector('.artwork-wallet-total').hidden = !digital;
      this.querySelector('.artwork-wallet-manual').hidden = !digital;
      this.querySelector('[data-checkout]').hidden = !digital && !this.pending;
      this.querySelector('[data-physical-rule]').hidden = !this.configured.length;
      const physicalList = this.querySelector('[data-configured-items]'); physicalList.replaceChildren();
      const physicalPayments = this.querySelector('[data-physical-payments]'); physicalPayments.replaceChildren(); physicalPayments.hidden = !this.configured.length;
      for (const item of this.configured) {
        const row = document.createElement('li'), image = document.createElement('img'), content = document.createElement('div'), link = document.createElement('a'), remove = document.createElement('button');
        image.width = 68; image.height = 76; image.alt = ''; image.loading = 'lazy'; if (item.image) image.src = item.image;
        link.href = item.url; link.textContent = item.title;
        const note = document.createElement('p'); note.textContent = `${item.label} · `;
        const itemPrice = document.createElement('span'); itemPrice.className = 'money'; itemPrice.textContent = this.money(item.priceCents); note.append(itemPrice, ` · ${item.country}`);
        const pay = document.createElement('button'); pay.type = 'button'; pay.className = 'artwork-wallet-secondary'; pay.textContent = this.copy('pay_physical'); pay.disabled = this.busy; pay.addEventListener('click', () => this.checkoutPhysical(item));
        const paymentLabel = document.createElement('p'); paymentLabel.textContent = `${item.title} · ${item.label}`;
        const paymentPrice = document.createElement('span'); paymentPrice.className = 'money'; paymentPrice.textContent = this.money(item.priceCents); pay.append(' — ',paymentPrice);
        physicalPayments.append(paymentLabel,pay);
        content.append(link,note); remove.type = 'button'; remove.textContent = this.copy('remove'); remove.disabled = this.pending || this.busy;
        remove.addEventListener('click', () => { this.configured = this.configured.filter(other => other !== item); this.requestKey = null; this.pendingState = null; this.save(); this.render(); });
        row.append(image,content,remove); physicalList.append(row);
      }
      this.querySelector('[data-address]').hidden = !this.configured.length && !this.nativeItems.some(item => item.requires_shipping && item.properties?.['_Artwork quote token']);
      const action = this.querySelector('[data-checkout]'); action.textContent = this.copy(this.pendingState === 'OPEN' ? 'resume' : 'checkout');
      action.disabled = this.busy || !this.storageOK || this.dataset.owner === 'guest' || frozen || (this.pending ? !['OPEN','RETRY_SAFE'].includes(this.pendingState) : !count || !this.wallet || this.wallet.available < count);
      this.querySelector('[data-retry]').hidden = !this.pending;
      this.querySelector('[data-retry]').disabled = this.busy;
      this.querySelectorAll('[data-pack]').forEach(button => { button.disabled = this.busy || this.pending; });
      if (!this.storageOK) this.message('storage');
      else if (this.pending) this.message(this.pendingMessage());
      else if (this.pendingState === 'COMPLETE') this.message('complete');
      else if (this.pendingState === 'RELEASED') this.message('released');
      else if (frozen) this.message('frozen');
      else if (this.dataset.owner === 'guest') this.message('login');
      else if (this.wallet && this.wallet.available < count) this.message('short');
      else if (this.wallet) this.querySelector('[data-status]').textContent = `${this.copy('available')} ${this.wallet.available}`;
      this.querySelectorAll('[data-address] input,[data-address] select').forEach(input => { input.disabled = this.pending || this.busy; });
    }
    renderNative() {
      const list = this.querySelector('[data-native-items]'); list.replaceChildren();
      this.nativeInvalid = false;
      for (const item of this.nativeItems) {
        if (!item.requires_shipping || !item.properties?.['_Artwork quote token']) continue;
        const row = document.createElement('li'), image = document.createElement('img'), content = document.createElement('div'), link = document.createElement('a');
        image.width = 68; image.height = 76; image.alt = ''; image.loading = 'lazy';
        try { const url = new URL(item.image,location.origin); if (url.protocol === 'https:' && [location.hostname,'cdn.shopify.com'].includes(url.hostname)) { url.searchParams.set('width','180'); image.src = url.href; } } catch {}
        try { const url = new URL(item.url,location.origin); if (url.origin === location.origin) link.href = url.pathname; } catch {}
        link.textContent = `${item.product_title} × ${item.quantity}`;
        const price = document.createElement('span'); price.textContent = this.money(item.final_line_price,this.nativeCurrency); content.append(link,price);
        row.append(image,content); list.append(row);
      }
      this.querySelector('[data-native-box]').hidden = !list.children.length;
      this.querySelector('[data-pack-resume]').hidden = !this.hasNativePack() && !this.packNeedsReview;
      this.querySelector('[data-address]').hidden = !this.configured.length && !this.nativeItems.some(item => item.requires_shipping && item.properties?.['_Artwork quote token']);
    }
    hasNativePack() { return this.nativeItems.some(item => ['48392184234210','48392184332514','48392184365282'].includes(String(item.variant_id || item.id))); }
    async api(action, body) {
      const url = new URL(this.endpoint); url.searchParams.set('mode','credits'); url.searchParams.set('action',action);
      const response = await fetch(url,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:body?{'Content-Type':'application/json','X-Artwork-CSRF':this.csrf}:{},body:body?JSON.stringify(body):undefined,signal:AbortSignal.timeout(30000)});
      let data; try { data = await response.json(); } catch { throw Error('UNAVAILABLE'); }
      if (!response.ok) throw Error(data.error || 'UNAVAILABLE'); return data;
    }
    async readNativeCart() {
      const url = new URL(this.dataset.nativeCart,location.origin); if (url.origin !== location.origin) throw Error('CART_UNAVAILABLE');
      const response = await fetch(url,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(15000)}); if (!response.ok) throw Error('CART_UNAVAILABLE');
      const cart = await response.json(); if (!Array.isArray(cart.items) || cart.items.length > 100) throw Error('CART_UNAVAILABLE');
      this.nativeItems = cart.items; this.nativeCurrency = cart.currency || 'EUR'; return cart.items;
    }
    async refresh(recover = false) {
      if (this.dataset.owner === 'guest' || this.refreshing || this.busy) return;
      this.refreshing = true;
      try {
        if (!this.pending) await this.readNativeCart();
        const result = await this.api('balance');
        if (!Number.isSafeInteger(result.balance?.available) || result.balance.available < 0 || typeof result.csrf !== 'string') throw Error('UNAVAILABLE');
        this.wallet = result.balance; this.csrf = result.csrf;
        if (recover && this.pending) await this.recover();
        this.render();
      } catch (error) { this.render(); this.message(error.message === 'LOGIN_REQUIRED' ? 'login' : this.pending ? this.pendingMessage() : 'error'); }
      finally { this.refreshing = false; }
    }
    safeCheckout(value) {
      const url = new URL(value), allowed = [this.dataset.shop,location.hostname,'checkout.shopify.com','alphareproduction.com'];
      if (url.protocol !== 'https:' || url.username || url.password || url.port || !allowed.includes(url.hostname)) throw Error('UNAVAILABLE'); return url.href;
    }
    async recover() {
      try { this.applyState(await this.api('status',{requestKey:this.requestKey})); }
      catch (error) {
        if (error.message !== 'CHECKOUT_NOT_FOUND') throw error;
        this.pendingState = this.requestItems ? 'RETRY_SAFE' : 'VERIFYING';
      }
    }
    applyState(result) {
      if (!['RESERVED','CREATE_PENDING','UNKNOWN','OPEN','COMPLETE','RELEASED'].includes(result.state)) throw Error('UNAVAILABLE');
      this.pendingState = result.state;
      if (result.state === 'OPEN') { this.checkoutUrl = this.safeCheckout(result.checkoutUrl); this.pending = true; }
      else if (result.state === 'COMPLETE') { this.items = []; this.pending = false; this.requestKey = null; this.checkoutUrl = null; this.message('complete'); }
      else if (result.state === 'RELEASED') { this.pending = false; this.requestKey = null; this.checkoutUrl = null; this.message('released'); }
      else { this.pending = true; this.checkoutUrl = null; }
      this.save();
    }
    async checkout() {
      if (this.busy || !this.storageOK || this.dataset.owner === 'guest') return;
      if (this.pending) {
        await this.refresh(true);
        if (this.pendingState === 'OPEN' && this.checkoutUrl && this.wallet?.frozen !== true) location.assign(this.safeCheckout(this.checkoutUrl));
        else if (this.pendingState === 'RETRY_SAFE' && this.requestItems && this.wallet?.frozen !== true) {
          this.busy = true; this.pendingState = 'VERIFYING'; this.render();
          try { this.applyState(await this.api('checkout',{requestKey:this.requestKey,items:this.requestItems})); if (this.pendingState === 'OPEN') location.assign(this.safeCheckout(this.checkoutUrl)); }
          catch { this.message(this.pendingMessage()); }
          finally { this.busy = false; this.render(); }
        }
        return;
      }
      if (!this.creditCount() || !this.wallet || this.wallet.available < this.creditCount() || this.wallet.frozen) return;
      this.busy = true; this.checkoutNotice = null; this.message('loading'); this.render();
      try {
        const current = await this.api('balance');
        if (!Number.isSafeInteger(current.balance?.available) || current.balance.available < 0 || typeof current.csrf !== 'string') throw Error('UNAVAILABLE');
        this.wallet = current.balance; this.csrf = current.csrf;
        if (this.wallet.frozen || this.wallet.available < this.creditCount()) { this.checkoutNotice = this.wallet.frozen ? 'frozen' : 'short'; return; }
        await this.readNativeCart(); this.renderNative();
        const items = this.items.map(item => ({productId:item.id,kind:'digital',quantity:1,useCredit:item.useCredit}));
        if (new TextEncoder().encode(JSON.stringify(items)).byteLength > 60000 || items.length > 100) throw Error('UNAVAILABLE');
        this.requestItems = items; this.requestKey ||= crypto.randomUUID(); this.pending = true; this.pendingState = 'VERIFYING'; this.save(); if (!this.storageOK) throw Error('STORAGE');
        const result = await this.api('checkout',{requestKey:this.requestKey,items}); this.applyState(result);
        if (this.pendingState === 'OPEN') location.assign(this.safeCheckout(this.checkoutUrl));
      } catch (error) {
        if (error.message === 'INSUFFICIENT_CREDITS' || error.message === 'WALLET_FROZEN') this.checkoutNotice = error.message === 'WALLET_FROZEN' ? 'frozen' : 'short';
        else this.checkoutNotice = this.pending ? this.pendingMessage() : 'error';
      } finally { this.busy = false; this.render(); if (this.checkoutNotice) this.message(this.checkoutNotice); }
    }
    async checkoutPhysical(item) {
      if (this.busy) return;
      const form = this.querySelector('[data-address]');
      form.querySelectorAll('input,select').forEach(input => { input.disabled = false; });
      if (!form.reportValidity()) return;
      const shippingAddress = Object.fromEntries(new FormData(form));
      const destination = shippingAddress.countryCode;
      const status = this.querySelector('[data-physical-status]'); status.hidden = false; status.textContent = this.copy('loading');
      this.busy = true; this.render(); this.message('loading');
      try {
        const option = await this.freshOption(item.variantId,destination,item.optionId);
        if (destination !== item.country || Math.round(option.totalPriceEur * 100) !== item.priceCents) { item.country = destination; item.priceCents = Math.round(option.totalPriceEur * 100); item.quoteToken = option.quoteToken; this.save(); throw Error('PRICE_CHANGED'); }
        const response = await fetch(this.endpoint,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({quoteToken:option.quoteToken,shippingAddress}),signal:AbortSignal.timeout(30000)});
        const result = await response.json(); if (!response.ok) throw Error('CHECKOUT_UNAVAILABLE');
        location.assign(this.safeCheckout(result.checkoutUrl));
      } catch (error) { this.busy = false; this.render(); const key = error.message === 'PRICE_CHANGED' ? 'physical_price_changed' : 'physical_error'; this.message(key); status.textContent = this.copy(key); status.scrollIntoView({block:'nearest'}); }
    }
    mountPhysicalActions() {
      document.querySelectorAll('[data-aap-root]').forEach(root => {
        root.querySelectorAll('[data-aap-sizes] button > span:not([data-credit-size-money])').forEach(label => {
          const match = label.textContent.match(/\d[\d\s\u00a0\u202f]*[,.]\d{2}\s*€/);
          if (!match) return;
          const text = label.textContent;
          const amount = document.createElement('span'); amount.className = 'money'; amount.textContent = match[0];
          label.dataset.creditSizeMoney = '';
          label.replaceChildren(document.createTextNode(text.slice(0,match.index)), amount, document.createTextNode(text.slice(match.index + match[0].length)));
        });
        const pay = root.querySelector('[data-aap-checkout]'), price = root.querySelector('[data-aap-price]');
        if (price?.classList.contains('aap-price-card__price')) {
          price.classList.replace('aap-price-card__price', 'aap-credit-total');
        }
        if (pay && price && !pay.disabled && !root.classList.contains('is-digital-selection')) {
          let amount = pay.querySelector('[data-credit-cta-total]');
          if (!amount) { amount = document.createElement('b'); amount.dataset.creditCtaTotal = ''; amount.style.display = 'block'; amount.style.fontSize = '.9em'; pay.append(amount); }
          const total = price.textContent.trim(); if (amount.textContent !== total) amount.textContent = total;
        }
        const checkout = root.querySelector('[data-aap-checkout]'); if (!checkout || root.querySelector('[data-credit-physical]')) return;
        const button = document.createElement('button'); button.type = 'button'; button.className = 'artwork-credit-add'; button.dataset.creditPhysical = ''; button.textContent = this.copy('add_physical'); button.style.marginTop = '10px';
        button.addEventListener('click', () => this.addConfigured(root,button),{signal:this.abort.signal}); checkout.insertAdjacentElement('afterend',button);
      });
    }
    physicalSelection(root) {
      const active = name => root.querySelector(`[data-aap-${name}] button[aria-pressed="true"]`);
      if (root.getAttribute('aria-busy') === 'true' || root.classList.contains('is-digital-selection')) throw Error('UNAVAILABLE');
      const selection = {variantId:`gid://shopify/ProductVariant/${root.dataset.aapVariant}`,country:root.querySelector('[data-aap-country]')?.value,support:active('supports')?.dataset.support,size:active('sizes')?.dataset.value,finish:active('finishes')?.dataset.value,frame:active('frames')?.dataset.value || 'none'};
      if (!selection.support || !selection.size || !selection.finish || !/^[A-Z]{2}$/.test(selection.country || '')) throw Error('UNAVAILABLE'); return selection;
    }
    async freshOption(variantId,country,optionId,selection) {
      const url = new URL(this.endpoint); url.searchParams.set('variant',variantId.replace('gid://shopify/ProductVariant/','')); url.searchParams.set('country',country);
      const response = await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(30000)}); if (!response.ok) throw Error('UNAVAILABLE');
      const data = await response.json(); if (!Array.isArray(data.options) || data.countryCode !== country) throw Error('UNAVAILABLE');
      const options = data.options.map(option => ({...option,id:option.id || [option.supportId,option.widthMm,option.heightMm,option.finishId,option.frameId || 'none'].join('::')}));
      const matches = options.filter(option => selection ? option.supportId === selection.support && [option.supportId,option.widthMm,option.heightMm].join('::') === selection.size && option.finishId === selection.finish && (option.frameId || 'none') === selection.frame : option.id === optionId).sort((a,b) => a.totalPriceEur - b.totalPriceEur);
      const option = matches[0]; if (!option || typeof option.quoteToken !== 'string' || !Number.isFinite(option.totalPriceEur) || option.totalPriceEur < 0) throw Error('UNAVAILABLE'); return option;
    }
    async addConfigured(root,button) {
      if (this.busy || this.pending || this.configured.length >= 10) { this.open(); return; }
      button.disabled = true;
      try {
        const selection = this.physicalSelection(root), option = await this.freshOption(selection.variantId,selection.country,null,selection);
        if (JSON.stringify(selection) !== JSON.stringify(this.physicalSelection(root))) throw Error('UNAVAILABLE');
        const source = root.closest('[data-aam-pod-product]')?.querySelector('[data-credit-add]'); if (!source) throw Error('UNAVAILABLE');
        const item = this.cleanConfigured({id:source.dataset.productId,title:source.dataset.title,url:source.dataset.url,image:source.dataset.image,variantId:selection.variantId,country:selection.country,optionId:option.id,quoteToken:option.quoteToken,priceCents:Math.round(option.totalPriceEur * 100),label:root.querySelector('[data-aap-selection]')?.textContent || `${option.widthMm/10} × ${option.heightMm/10} cm`});
        if (!item) throw Error('UNAVAILABLE');
        if (!this.configured.some(other => other.id === item.id && other.optionId === item.optionId && other.country === item.country)) this.configured.push(item);
        this.requestKey = null; this.pendingState = null; this.save(); this.open(); this.message('physical_added');
      } catch { this.open(); this.message('physical_missing'); }
      finally { button.disabled = false; }
    }
    async buyPack(variant) {
      if (this.busy || this.pending) return;
      if (this.dataset.owner === 'guest') { location.assign(this.querySelector('[data-login]').href); return; }
      if (!['48392184234210','48392184332514','48392184365282'].includes(variant)) return;
      this.busy = true; this.save(); this.render(); this.message('loading'); let failed = false;
      try {
        await this.readNativeCart();
        const packIds = ['48392184234210','48392184332514','48392184365282'];
        const selected = () => this.nativeItems.some(item => String(item.variant_id || item.id) === variant);
        if (!selected()) {
          const url = new URL(this.dataset.nativeAdd,location.origin); if (url.origin !== location.origin) throw Error('PACK');
          const response = await fetch(url,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variant,quantity:1}]}),signal:AbortSignal.timeout(20000)});
          if (!response.ok) throw Error('PACK');
          await this.readNativeCart();
          if (!selected()) throw Error('PACK');
        }
        const obsolete = this.nativeItems.filter(item => packIds.includes(String(item.variant_id || item.id)) && String(item.variant_id || item.id) !== variant);
        if (obsolete.length) {
          const updateUrl = new URL(this.dataset.cartUrl.replace(/\/$/,'') + '/update.js',location.origin);
          if (updateUrl.origin !== location.origin || obsolete.some(item => !item.key)) throw Error('PACK');
          const response = await fetch(updateUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:Object.fromEntries(obsolete.map(item => [item.key,0]))}),signal:AbortSignal.timeout(20000)});
          if (!response.ok) throw Error('PACK');
        }
        await this.readNativeCart();
        if (!selected() || this.nativeItems.some(item => packIds.includes(String(item.variant_id || item.id)) && String(item.variant_id || item.id) !== variant)) throw Error('PACK');
        location.assign(this.dataset.cartUrl);
      } catch { failed = true; }
      finally { this.busy = false; this.packNeedsReview = failed; this.render(); if (failed) this.message('pack_error'); }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
